import _ from "lodash";
import { popUp } from "../controls/popUp";
import { ll, LocalizedLanguage } from "../core/ll";
import { user } from "../core/user";
import { schemas } from "../data/schemas";
import { searchTypes } from "../data/searchTypes";
import { Grid, GridOptions } from "./components/grid";

/*
    * SearchPopUp
    * Opens a search pop up
    *
    * Required options
    * id
    *
    * types - array of types you wish to display
    * types will be an object containing:
    * name - name of the type
    * buttons - buttons that type can do (add new)
    * searchOptions - list of columns the user can search on
    *
    *
    * Ends up calling the z.controls.popUp() function
    *
    */
export function searchPopUp(options) {
    options = options || {};
    options.codeColumnsToIgnore = options.codeColumnsToIgnore || [];
    options.elementToSetValue = options.elementToSetValue || "";
    options.valueToSelect = options.valueToSelect || "";

    if (options.entityType) {
        options.types = options.types || [
            searchTypes.generate(options.entityType.toLowerCaseFirstLetter)
        ];

        options.title = options.title || ll(options.entityType.toUpperCaseFirstLetter);
        options.id = options.id || options.entityType + "SearchPopUp";
    }

    if (!options.id) {
        throw new Error("This function requires you send in an id.");
    }

    if (!options.types && options.types.length > 0) {
        throw new Error("This function requires you send in a types list.");
    }

    options.title = options.title;

    options.overlay = true;

    let okClicked = false;

    var okButton = {
        name: options.okText || "OK",
        id: options.id + "_OK",
        clickEvent: function (e) {
            if (!okClicked) {
                okClicked = true;
                var searchWindow: any = $("#" + options.id).data("kendoWindow");
                var tabs = searchWindow.element.find(".k-tabstrip").data("kendoTabStrip");
                if (tabs) {
                    var tabStrip = $("#" + options.id + "_UL"),
                        tabElements = tabStrip.find("li"),
                        selectedTab = tabStrip.find(".k-state-active"),
                        selectedIndex = tabElements.index(selectedTab),
                        selectedTabEntityType = options.types[selectedIndex].entityType;

                    searchWindow.selectedTabText = selectedTab.text();
                    searchWindow.selectedTab = selectedTabEntityType;
                }
                searchWindow.searchResults = thePopUp.getSelectedItem();

                options.okClick && options.okClick(e);

                $.wait(500).then(() => okClicked = false);
            }
        }
    };

    var buttonsFound = options.buttons;

    options.buttons = options.buttons || [
        okButton,
        {
            name: options.cancelText || ll("Cancel"),
            clickEvent: options.cancelClick
        }
    ];

    if (options.okClick && buttonsFound) {
        options.buttons.unshift(okButton);
    }

    if (options.addClick) {
        options.buttons.unshift(
        {
            name: options.addButtonText || ll("Add"),
            id: options.id + "_Add",
            clickEvent: function (e) {
                e.preventDefault();
                options.addClick && options.addClick(e);
            }
        });
    }

    options.autoHeight = {
        topMargin: 130,
        estimatedHeight: 0
    };

    if (!options.height || options.height == "auto") {
        options.estimatedHeight = getDefaultHeight(options);
    }

    options.width = options.width || ($(document).width() - 200 || 800);

    options.classes = [
        "search-popup"
    ];

    var thePopUp = popUp(options);

    options.id = thePopUp.id + "_" + options.id;
    thePopUp.setGuts("<div id='" + options.id + "_Guts'></div>");

    thePopUp.guts.css({ height: "auto", padding: 0 });

    thePopUp.selectedTabIndex = 0;

    thePopUp.getSelectedItem = function () {
        var searchWindow = $("#" + options.id).data("kendoWindow");
        var tabs = searchWindow.element.find(".k-tabstrip").data("kendoTabStrip");
        var selectedGrid = searchWindow.element.find(".k-grid").data("kendoGrid");
        if (tabs) {
            selectedGrid = $(tabs.tabGroup.context).find(".k-state-active .k-grid").data("kendoGrid");
        }

        if (selectedGrid) {
            return selectedGrid.dataItem(selectedGrid.select());
        }
    };

    var tabCount = 0;

    $.each(options.types, function (index: any, type) {
        if (type.divisionAndRegionOnly) {
            if (user &&
                user.companyData &&
                user.companyData.DivisionAndRegionEnabled) {
                tabCount++;
            }
        } else {
            tabCount++;
        }
    });

    // Create tabs for each type if more than one
    if (options.types && tabCount > 1) {
        $('<div id="' + options.id + '_TabStrip">' +
            '<ul id="' + options.id + '_UL"></ul>' +
            "</div>").appendTo("#" + options.id + "_Guts");

        buildSearchWindowContents(options);

        $("#" + options.id + "_TabStrip").kendoTabStrip({
            select: function (e) {
                var kgrid = $(e.contentElement).find(".k-grid");
                var kendoGrid = kgrid.data("kendoGrid");

                var data = kendoGrid.dataSource.data();
                if (data.length == 0) {
                    kendoGrid.content.append("<div class='k-loading-mask'style='width:100%;height:100%'><div class='k-loading-image'></div></div>");

                    var filterDataButton = kendoGrid.element.siblings(".search-contents").find(".filter-data-button");

                    if (filterDataButton) {
                        filterDataButton.click();
                    } else {
                        kendoGrid.zRefresh();
                    }
                }

                thePopUp.selectedTabIndex = $(e.item).index();
                options.tabSelect && options.tabSelect(e);
            }
        });
    } else {
        var currentType = options.types[0];
        var entityType = "grid";
        if (currentType.entityType) {
            entityType = currentType.entityType.replaceAll("/", "-");
        }
        currentType.type = "Grid";
        currentType.id = currentType.id || options.id + "_" + currentType.entityType.replaceAll("/", "_");
        currentType.searchClasses = currentType.searchOptions && currentType.searchOptions.length > 0 ? "pad-t-13" : "";
        currentType.classes = entityType;
        var gridLayout = new Grid({
            id: currentType.id,
            searchClasses: currentType.searchClasses,
            classes: currentType.classes,
            stickyDefaultName: entityType
        });
        gridLayout.render("#" + options.id + "_Guts");
        buildSearchWindowContents(options);
    }

    kendo.bind(thePopUp.get(".bind-label"), LocalizedLanguage);

    return thePopUp;
}

function getDefaultHeight(options) {
    var height = (window.innerHeight - (Math.max(options.autoHeight.topMargin - $(window).scrollTop(), 0))) * .90;

    if (height < 400) {
        height = 400;
    }

    return height;
}

export function buildSearchWindowContents(options) {

    $.each(options.types, function (index: any, currentType) {
        if (currentType.divisionAndRegionOnly &&
            user &&
            user.companyData &&
            user.companyData.DivisionAndRegionEnabled == false) {
            return;
        }

        var entityType = currentType.entityType;
        if (currentType.title) {
            entityType = currentType.title;
        } else if (currentType.entityType) {
            entityType = currentType.entityType.replaceAll("/", "-");
        }
        currentType.type = "Grid";

        var name = entityType.toUpperCaseFirstLetter();

        if (index == 0) {
            $('<li class="k-state-active">' + ll(name, true) + "</li>").appendTo("#" + options.id + "_UL");
        } else {
            $("<li>" + ll(name, true) + "</li>").appendTo("#" + options.id + "_UL");
        }

        currentType.type = "Grid";
        currentType.id = currentType.id || entityType;
        currentType.searchClasses = currentType.searchOptions && currentType.searchOptions.length > 0 ? "pad-t-13" : "";
        currentType.classes = entityType;
        var gridLayout = new Grid({
            id: currentType.id,
            searchClasses: currentType.searchClasses,
            classes: currentType.classes,
            stickyDefaultName: entityType
        });
        gridLayout.render("#" + options.id + "_TabStrip");

        // Create grids for each type
        var gridElement = $("#" + currentType.id);

        var gridHeight = getHeight(options.estimatedHeight);
        var pageSize = getPageSize(gridHeight);

        if (options.deletePopUp) {
            currentType.searchOptions = null;
        }

        var gridOptions: GridOptions = {
            id: currentType.id,
            height: gridHeight,
            entity: currentType.entityType,
            url: currentType.url,
            columnOverrides: schemas[currentType.entityType] ? currentType.columns : undefined,
            gridColumns: schemas[currentType.entityType] ? undefined : currentType.columns,
            utilityColumns: currentType.utilityColumns,
            columnOrder: currentType.columnOrder,
            columnRenames: currentType.columnRenames,
            searchOptions: currentType.searchOptions,
            sort: currentType.sort,
            regionsFilterOverride: currentType.regionsFilterOverride,
            filter: currentType.filter,
            alwaysSelect: currentType.select ? currentType.select.split(/[ ,]+/).filter(Boolean) : [],
            expand: currentType.expand ? currentType.expand.split(/[ ,]+/).filter(Boolean) : [],
            searchType: currentType,
            dataSource: currentType.dataSource,
            autoBind: false,
            selectable: true,
            change: currentType.change,
            pageSize: pageSize,
            dataBound: currentType.dataBound,
            stickyDefaultName: currentType.stickyDefaultName || currentType.entityType,
            urlPrefix: options.urlPrefix,
            urlPostfix: currentType.urlPostfix,
            beforeSend: options.beforeSend,
            companyGuid: options.companyGuid
        };

        gridOptions.isSearchPopUp = true;
        gridLayout.build(gridOptions);

        gridElement.on("dblclick", ".k-grid-content tr", function () {
            $("#" + options.id + "_OK").click();
        });

        if (index == 0) {
            $("#" + currentType.id + "_filterDataButton").click();
        }

        if (currentType.guts) {
            gridElement.after(currentType.guts);
        }
    });
}

function getHeight(parentWindowHeight) {
    // subtract 100 for the header and 80 for
    // the footer.  Then the height is 90 percent
    // of that balance
    return Math.round((parentWindowHeight - 180) * .95);
}

function getPageSize(gridHeight) {
    // each row is roughly 27 px tall subtract (27 * 2) for the header and footer
    var pageSizes = [5, 10, 15, 25, 50, 100, 500];
    var gridRowHeight = (gridHeight - (27 * 2));
    var estimatedRowCount = Math.round(gridRowHeight < 27 ? 10 : gridRowHeight / 27);

    var pageSize = 10;
    $.each(pageSizes, function (index, pageSizeInstance) {

        if (estimatedRowCount < pageSizeInstance) {
            pageSize = pageSizes[index - 1];
            return false;
        }

        return true;

    });

    return pageSize;
}
